export function updateMetaTag(name, content) {
  let metaTag = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  if (!metaTag) {
    metaTag = document.createElement('meta');
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      metaTag.setAttribute('property', name);
    } else {
      metaTag.setAttribute('name', name);
    }
    document.head.appendChild(metaTag);
  }
  metaTag.setAttribute('content', content);
}

export function updateCanonical(href) {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', href);
}

export function updatePageMeta({ title, description, path }) {
  const canonical = path.startsWith('http') ? path : `https://palette.site${path}`;

  document.title = title;
  updateMetaTag('description', description);
  updateMetaTag('twitter:title', title);
  updateMetaTag('twitter:description', description);
  updateMetaTag('og:title', title);
  updateMetaTag('og:description', description);
  updateCanonical(canonical);
}

export function updateRobotsMeta(content) {
  let robotsMeta = document.querySelector('meta[name="robots"]');
  if (content) {
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', content);
  } else if (robotsMeta) {
    robotsMeta.remove();
  }
}
